import { useServices } from '@/components/Services';
import { fileActions } from '@/containers/App/actions';
import type { DeleteFileArg, DeleteFileResult } from '@/services/api/files';
import { MUTATION_KEYS } from '@/utils/mutationKeys';
import { QUERY_KEYS } from '@/utils/queryKeys';
import { captureException } from '@sentry/react';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

export const useDeleteFile = (): UseMutationResult<DeleteFileResult, unknown, DeleteFileArg, unknown> => {
  const { filesApiClient } = useServices();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: DeleteFileArg) => await filesApiClient.delete(id),
    mutationKey: MUTATION_KEYS.files.delete(),
    onError: error => {
      console.error(error);
      captureException(error);
      dispatch(fileActions.deleteFile.error());
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.files.all());
      dispatch(fileActions.deleteFile.success());
    },
  });
};
